import { List, Typography } from "antd";
import { useEffect, useMemo, useState } from "react";
import { SpeedItemData } from "../types/types";

const { Text } = Typography;

const kBlockHeight = {
  query: "{\n  _meta{\n    block{\n      number\n    }\n  }\n}\n",
};
interface ITheGraphSpeedItem {
  item: SpeedItemData;
}
const TheGraphSpeedItem = (props: ITheGraphSpeedItem) => {
  const { item } = props;
  const [speed, setSpeed] = useState(NaN);
  const [reason, setReason] = useState("-");
  const [hasError, setHasError] = useState(false);
  useEffect(() => {
    if (item.url) {
      const start = Date.now();
      fetch(item.url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(kBlockHeight),
      })
        .then((res) => {
          if (res.status === 200) {
            res
              .text()
              .then((content) => {
                setReason(content);
                try {
                  const contentObject = JSON.parse(content);
                  setReason(contentObject["data"]["_meta"]["block"]["number"]);
                } catch (error) {
                  setHasError(true);
                }
              })
              .finally(() => {
                setSpeed(Date.now() - start);
              });
          } else {
            setHasError(true);
            setReason(`Error Code: ${res.status}`);
          }
        })
        .catch(() => {
          setHasError(true);
        })
        .finally(() => {
          setSpeed(Date.now() - start);
        });
    }
  }, [item]);
  const itemStatus = useMemo(() => {
    console.log(hasError, speed);
    const isError = hasError || speed > 2000;
    const isWarning = !hasError && speed < 2000 && speed > 1000;
    const isNormal = !hasError && speed < 1000;
    return isError ? "🔴" : isWarning ? "🟠" : isNormal ? "🟢" : "⚪";
  }, [hasError, speed]);
  return (
    <List.Item>
      <List.Item.Meta avatar={itemStatus} title={item.name} />
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-start",
        }}
      >
        <Text>{reason}</Text>
        <Text type="secondary">{speed}ms</Text>
      </div>
    </List.Item>
  );
};

export default TheGraphSpeedItem;
